import { BehaviorSubject } from 'rxjs';

export class LoadingBehaviorSubject extends BehaviorSubject<boolean> {
    constructor(value: boolean = false) {
        super(value);
    }

    public startLoading(): void {
        this.next(true);
    }

    public stopLoading(): void {
        this.next(false);
    }
}
